import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

@Component({
  templateUrl: './search.view.html',
  styleUrls: ['./search.view.scss'],
})
export class SearchView implements OnInit, OnDestroy {
  searchTerm?: string;
  subscriptions = new Subscription();

  constructor(private activatedRoute: ActivatedRoute, private router: Router) {}

  ngOnInit(): void {
    this.subscriptions.add(
      this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
        const textParam = this.activatedRoute.snapshot.queryParamMap.get('text');
        if (textParam) {
          this.searchTerm = textParam.split(':')[0];
        }
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
